import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBankAccount = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 70,
	height: 48,
	viewBox: "0 0 70 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 6C0 2.68629 2.68629 0 6 0H64C67.3137 0 70 2.68629 70 6V42C70 45.3137 67.3137 48 64 48H6C2.68629 48 0 45.3137 0 42V6Z",
			fill: "#EFEDF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M26.6669 22.333C27.2192 22.333 27.6669 22.7807 27.6669 23.333V33.6663C27.6669 34.2186 27.2192 34.6663 26.6669 34.6663C26.1146 34.6663 25.6669 34.2186 25.6669 33.6663V23.333C25.6669 22.7807 26.1146 22.333 26.6669 22.333ZM32.0002 22.333C32.5525 22.333 33.0002 22.7807 33.0002 23.333V33.6663C33.0002 34.2186 32.5525 34.6663 32.0002 34.6663C31.4479 34.6663 31.0002 34.2186 31.0002 33.6663V23.333C31.0002 22.7807 31.4479 22.333 32.0002 22.333ZM38.0002 22.333C38.5525 22.333 39.0002 22.7807 39.0002 23.333V33.6663C39.0002 34.2186 38.5525 34.6663 38.0002 34.6663C37.4479 34.6663 37.0002 34.2186 37.0002 33.6663V23.333C37.0002 22.7807 37.4479 22.333 38.0002 22.333ZM43.3335 22.333C43.8858 22.333 44.3335 22.7807 44.3335 23.333V33.6663C44.3335 34.2186 43.8858 34.6663 43.3335 34.6663C42.7813 34.6663 42.3335 34.2186 42.3335 33.6663V23.333C42.3335 22.7807 42.7813 22.333 43.3335 22.333Z",
			fill: "#46434F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M34.3327 13.5884C34.7125 13.2479 35.2879 13.2479 35.6678 13.5884L45.3344 22.2551C45.643 22.5317 45.7489 22.97 45.6008 23.357C45.4527 23.7441 45.0813 23.9997 44.6669 23.9997H25.3335C24.9191 23.9997 24.5477 23.7441 24.3996 23.357C24.2515 22.97 24.3574 22.5317 24.666 22.2551L34.3327 13.5884ZM27.9469 21.9997H42.0535L35.0002 15.6761L27.9469 21.9997Z",
			fill: "#46434F"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.3335 33.6663C24.3335 33.1141 24.7813 32.6663 25.3335 32.6663H44.6669C45.2192 32.6663 45.6669 33.1141 45.6669 33.6663C45.6669 34.2186 45.2192 34.6663 44.6669 34.6663H25.3335C24.7813 34.6663 24.3335 34.2186 24.3335 33.6663Z",
			fill: "#46434F"
		})
	]
});
export default SvgBankAccount;
